import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  count: Number(localStorage.getItem("count")) || 0, // Load count from localStorage
};

// BroadcastChannel with fallback for incognito/restricted contexts
let channel = null;
try {
  channel = new BroadcastChannel("redux_sync");
} catch (e) {
  // BroadcastChannel not available (incognito mode, iframe restrictions, etc.)
}

const countSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    increment: (state) => {
      state.count += 1;
      localStorage.setItem("count", state.count); // Save count to localStorage
      // Notify other tabs (if BroadcastChannel is available)
      try {
        channel?.postMessage({ type: "UPDATE_COUNT", payload: state.count });
      } catch (e) {
        // Silently ignore if posting fails
      }
    },
    setCount: (state, action) => {
      state.count = action.payload;
    },
  },
});

export const { increment, setCount } = countSlice.actions;
export default countSlice.reducer;
